// One page size for every server-paginated list (DESIGN-CONCEPT §9.1: "Page size
// fixed at 20 (one constant in src/constants/), navigated by the shared Pager").
// Consumers: Encounters, as the size of one scroll step on the desktop and of one
// «نمایش بیشتر» step on the phone (PM-0533 — the desktop list scrolls instead of
// paging; see DESIGN_SYSTEM §15). Accounting still carries its legacy 50 — migrate
// it to this constant when that screen is next touched.
export const PAGE_SIZE = 20;
